var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "document-validation",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__(
        "listing.batchComponents.DocumentValidation.validate_document"
      )
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Les documents sélectionnés vont être validés à la date d'aujourd'hui"
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: { click: _vm.close }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.confirm"),
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }